module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SignInSuccessView.js"));
	}, "SignInSuccessView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SignInSuccessView!./src/pages/Promote/OfflineActivity/SignInSuccess/SignInSuccessView.js
// module id = 1175
// module chunks = 431